import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('tr',[_c('td',{attrs:{"colspan":_vm.colspan}},[_c(VProgressLinear,{attrs:{"height":3,"color":"red","indeterminate":""}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }